import { render, staticRenderFns } from "./Emergency.vue?vue&type=template&id=cf33b9f8&scoped=true&"
import script from "./Emergency.vue?vue&type=script&lang=js&"
export * from "./Emergency.vue?vue&type=script&lang=js&"
import style0 from "./Emergency.vue?vue&type=style&index=0&id=cf33b9f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf33b9f8",
  null
  
)

export default component.exports